import React from "react";
import { InvoiceDetailsDto } from "../../../models/transportOrderInvoice/invoiceDetailsDto";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { TransportOrderInvoiceEdit } from "./TransportOrderInvoiceEdit";
import { useAppSelector } from "../../../framework/customStore";
import { fetchTransportOrderInvoice, selectEditEnabled } from "../../../store/transportOrderInvoiceSlice";
import { TransportOrderInvoiceState } from "../../../models/transportOrderInvoice/transportOrderInvoice";
import Grid2 from "@mui/material/Unstable_Grid2";
import { IIdTitle } from "../../../models/common/idTitle";
import MuiMenu from "../../framework/muiMenu";
import { useTranslation } from "react-i18next";

interface IInvoiceDetailsModalProps {
    id: string;
    invoiceDetails: InvoiceDetailsDto;
    open: boolean;
    integrations: IIdTitle[];
    handleClose: () => void;
    handleRemoveInvoice: (id: string) => void;
    handleApproveInvoice: (id: string, invoiceState: number) => void;
    handleSendToIntegration: (id: string, integrationId: string) => void;
}

export const InvoiceDetailsModal = ({
    id,
    invoiceDetails,
    handleClose,
    open,
    handleRemoveInvoice,
    handleApproveInvoice,
    integrations,
    handleSendToIntegration,
}: IInvoiceDetailsModalProps) => {
    const editEnabled = useAppSelector(selectEditEnabled);
    const { t } = useTranslation();

    return (
        <Dialog onClose={handleClose} open={open} maxWidth="xl" fullWidth>
            <Grid2 container style={{ margin: 25 }}>
                <Grid2 xs={10}>
                    <DialogTitle>{t("invoice.details")}</DialogTitle>
                </Grid2>
                {invoiceDetails.state ===
                    TransportOrderInvoiceState.NotApproved && (
                    <Grid2
                        xs={2}
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                            padding: 8,
                        }}
                    >
                        <Button
                            onClick={() => {
                                handleRemoveInvoice(id);
                                fetchTransportOrderInvoice(id);
                            }}
                            variant="contained"
                            color="error"
                            style={{ marginBottom: "6px" }}
                        >
                            {t("common.removeInvoice")}
                        </Button>
                    </Grid2>
                )}
            </Grid2>
            <DialogContent>
                <TransportOrderInvoiceEdit id={id} disableEdit={true} />
            </DialogContent>
            <DialogActions style={{ margin: 25 }}>
                {editEnabled && (
                    <Button
                        onClick={() => {
                            handleApproveInvoice(
                                id,
                                TransportOrderInvoiceState.Approved
                            );
                        }}
                        size="large"
                        color="success"
                        variant="contained"
                        disabled={!invoiceDetails?.transportOrderRows}
                    >
                        {t("common.approveInvoice")}
                    </Button>
                )}

                {invoiceDetails.state === TransportOrderInvoiceState.Approved &&
                integrations?.length > 0 ? (
                    <MuiMenu
                        loading={invoiceDetails.sendingToIntegration}
                        size="large"
                        iconButton={false}
                        buttonColor="success"
                        label={t("common.send")}
                        items={integrations.map((i) => ({
                            label: i.title,
                            onClick: () => handleSendToIntegration(id, i.id),
                        }))}
                    />
                    ) : null}

                <Button size="large" variant="contained" onClick={handleClose}>
                    {t("common.close")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
